/**
 * 绑定手机
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import Modal from 'boron/ScaleModal';
import BindPhonePopView from './bindphone-view';

const noop = function(){};

const style = {
    modalStyle: {
         width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class BindPhonePop  extends Component {
    static defaultProps = {
        content: '',
        onHide: noop,
        onComplete: noop
    }
    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.showModal();
    }
  
    onHide() {
        // 在隐藏动画执行完成之后再触发事件onConfirm
        if (this.status == 'confirm') {
            this.props.onComplete(this.mobilePhone);
        }

        this.props.onHide();
    }
    onClose() {
        this.hideModal();
        this.status = 'cancel';
    }

    showModal() {
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    bindphoneComplete(mobilePhone) {
        this.hideModal();
        this.status = 'confirm';
        this.mobilePhone = mobilePhone;
    }

    render() {
        let modalStyle = style.modalStyle;
        let backdropStyle = style.backdropStyle;
        let contentStyle = style.contentStyle;
        
        if (this.props.modalStyle) {
            for (let style in this.props.modalStyle) {
                modalStyle[style] = this.props.modalStyle[style];
            }
        }

        if (this.props.backdropStyle) {
            for (let style in this.props.backdropStyle) {
                backdropStyle[style] = this.props.backdropStyle[style];
            }
        }

        if (this.props.contentStyle) {
            for (let style in this.props.contentStyle) {
                contentStyle[style] = this.props.contentStyle[style];
            }
        }

        return (
            <Modal 
                ref="modal"  
                closeOnClick={false}              
                onHide={this.onHide.bind(this)}
                modalStyle={modalStyle}  
                backdropStyle={backdropStyle} 
                contentStyle={contentStyle}
            >

                <div className="bind-pop">
                    <div className="box">
                        <div className="bind-pop-hd">
                            <span className="close" onClick={()=>this.onClose()}>x</span>
                        </div>
                        <BindPhonePopView onComplete={this.bindphoneComplete.bind(this)}/>
                    </div>
                </div>
            </Modal>
        );
    }
}

module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <BindPhonePop {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function(){
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/mall/withdraw/bindphone-pop.js